module.exports = __webpack_public_path__ + "img/survey.2ddedfb4.svg";